import React from 'react';
import MainCalculatorsList from '../MainCalculators';
import SharedHelmet from '../Helmet';
import RelatedLinks from '../RelatedLinks';
import { CalculatorsType } from '../ConstantsEN';
import { FirstAds, SecondAds , MobileUnderCalAds } from "../../Ads";
import SharedGradeUk from './SharedGradeUk';
const TITLE = 'UK GPA Calculator - Convert University GPA to British Grading System - Bachelor’s & Master’s';
const DESCRIPTION = "Easily and accurately convert your university GPA to the British grading system by using the UK GPA Calculator. Learn how to convert Bachelor's and Master's GPAs from the university system to the British system using this helpful UK GPA Calculator.";
const KEYWORDS = "UK GPA Calculator, Convert University GPA, Convert to British Grading System, Convert Bachelor's GPA, Convert Master's GPA, University GPA, British Grading System,UK Grades to GPA,UK masters gpa calculator, uk honours to gpa";
const OG_URL = 'https://do-calculate.com/calculator/en/gradetouk';
function GradeToUk() {
  return (
    <div>
      <SharedHelmet TITLE={TITLE} DESCRIPTION={DESCRIPTION} KEYWORDS={KEYWORDS} OG_URL={OG_URL}  />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div className="bg-success text-white text-center" style={{ height: '40px' }}>
            <h1 style={{ fontSize: '17px' }}>{TITLE}</h1>
          </div>
              <div className="border border-light">
                <div className="row">
                  <div>
                    <p>
                     The UK GPA Calculator helpes you to easily and accurately convert your university GPA (cumulative or yearly) to the British grading system. Learn how to convert Bachelor's and Master's GPAs from the university system to the British system using this helpful tool.
                    </p>
                  </div>
                  <br />
                </div>
                <hr />
                <MobileUnderCalAds/>
                <div className="row">
                  <div className="col">
                    <SharedGradeUk />
                  </div>
                </div>
                <hr />
                <div className="row">
                  <RelatedLinks />
                  <hr />
                </div>
              </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList CalculatorsTypeId={CalculatorsType.studyCalculators} />
          <br />
        </div>
      </div>
      <div className="row" style={{ height: 'auto' }}>
        <div className="col-12 col-md-8">
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header">{TITLE}</div>
              <div className="info-section-body">
                <div>
                  <u><h2 style={{ fontSize: '16px' }}>UK University Grading System</h2></u>
                    In the UK, universities offer two types of bachelor's degrees: Honours and Ordinary degrees.
                    <br />
                    Honours degrees are the most common. You can complete an Honours degree with different classifications based on your grades. Depending on your overall grade, you can achieve 4 types of Honours degrees upon graduation:
                    <br/>                    <b>First-Class Honours (1st):</b> Equivalent to grade A. You need to complete your studies with an overall grade of 70% or higher. It's an excellent academic achievement and is advantageous when applying for a Master's degree or a job.
                    <br />
                    <b>Upper Second-Class Honours (2:1):</b> Equivalent to grade B. You need an overall grade ranging from 60-69% to attain this classification. This type of degree is a common requirement when applying for Master's programs.
                    <br />
                    <b>Lower Second-Class Honours (2:2):</b> Equivalent to grade C. To achieve this classification, you need an overall grade ranging from 50-59%. While it's not as prestigious as First-Class Honours or 2:1, it's still accepted by some Master's programs.
                    <br />
                    <b>Third-Class Honours (3rd):</b> Equivalent to grade D. This classification is awarded to students who complete their studies with an overall grade ranging from 40-49%. While it's a passing grade, it can be challenging to compete with other students when applying for a Master's program.
                    <br/>                    <div className="p-3 mb-2 bg-warning text-dark">
                      If your overall grade is less than 40%, you are considered to have failed, which is equivalent to receiving an F grade.
                    </div>
                </div>
                <hr />
                <div>
                  <u><h2 style={{ fontSize: '16px' }}>UK Postgraduate Grading System</h2></u>
                    The postgraduate grading system for Master's degrees in the UK is similar to the Honours system but differs in some points. The minimum passing grade is 50% instead of 40%. The complete classifications for The UK Masters GPA calculator look as follows:
                    <ul>
                      <li>Distinction: 70-100%</li>
                      <li>Merit: 60-69%</li>
                      <li>Pass: 50-59%</li>
                      <li>Fail: Less than 50%</li>
                    </ul>
                </div>
                <hr />
                <div>
                  <u><h2 style={{ fontSize: '16px' }}>Converting British Grades to Cumulative GPA (UK Grades to GPA)</h2></u>
                    American universities and colleges typically use the Grade Point Average (GPA) to assess overall student performance. The GPA is calculated using your grades and the number of credit hours for each course you take. The approximate conversion of British grades to Cumulative GPA looks as follows:
                    <table >
                    <tbody>
                      <tr className='bmi-header'>
                        <th>British Grading</th>
                        <th>Cumulative GPA</th>
                      </tr>
                      <tr>
                        <td>First-Class Honours (1st)</td>
                        <td>4.0</td>
                      </tr>
                      <tr>
                        <td>Upper Second-Class Honours (2:1)</td>
                        <td>3.3 - 3.9</td>
                      </tr>
                      <tr>
                        <td>Lower Second-Class Honours (2:2)</td>
                        <td>2.7 - 3.2</td>
                      </tr>
                      <tr>
                        <td>Third-Class Honours (3rd)</td>
                        <td>2.0 - 2.6</td>
                      </tr>
                      <tr>
                        <td>Pass</td>
                        <td>1.0 - 1.9</td>
                      </tr>
                      <tr>
                        <td>Fail</td>
                        <td>0.0</td>
                      </tr>
                      </tbody>
                    </table>
                  <div className="p-3 mb-2 bg-warning text-dark">
                    Less than 40% = 1.0-1.9 – This is not necessarily a fail; in some universities, it may be equivalent to an Ordinary degree in the UK.
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
         </div>
</div>
  );
}
export default GradeToUk;
